/* eslint-disable no-unused-vars */
// import * as types from './actionTypes';
import { fromJS } from 'immutable';
import { get } from 'lodash-es';
import * as types from './actionTypes';
import initialState from '../../Store/initialState';

let newState;

const theme = (state = initialState.get('theme'), action) => {
  try {
    switch (action.type) {
      case types.UPDATE_THEME: {
        newState = state.setIn(['current'], get(action, 'theme.current', 'coog'));
        newState = newState.setIn(['logo', 'current'], get(action, 'theme.logo.current', 'coog'));
        return newState;
      }
      case types.FETCH_THEME_SUCCESS: {
        newState = state.setIn(['current'], get(action, 'data.theme'));
        newState = newState.setIn(['logo', 'current'], get(action, 'data.theme'));
        localStorage.setItem('theme', JSON.stringify(newState));
        return newState;
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default theme;
